import React, { useState, useEffect } from "react";
import { storage, ref, uploadBytes, getDownloadURL } from "../../firebase";

const FileUploader = ({
  label,
  fieldName,
  required = true,
  setValue,
  inputRef,
  setDocRef,
  docRef,
}) => {
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [uploaded, setUploaded] = useState(false);
  const [error, setError] = useState(null);

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setUploaded(false);
      setFile(null);
      setDocRef("");
      setFile(selectedFile);
    }
  };

  const handleUpload = async () => {
    if (!file) return;

    setUploading(true);
    setError(null);

    try {
      const randomSuffix = Math.floor(Math.random() * 10000); // Génère un nombre aléatoire entre 0 et 9999
      const fileExtension = file.name.split(".").pop(); // Récupère l'extension du fichier
      const fileName = `${
        file.name.split(".")[0]
      }_${randomSuffix}.${fileExtension}`; // Ajoute le suffixe avant l'extension
      const fileRef = ref(storage, `documents/${fileName}`); // Stockage dans Firebase avec un chemin spécifique
      const snapshot = await uploadBytes(fileRef, file);
      const downloadURL = await getDownloadURL(snapshot.ref);

      // Mettre l'URL dans le champ "document" du formulaire
      setValue(fieldName, downloadURL);
      setUploading(false);
      setUploaded(true);
      setDocRef(downloadURL);
    } catch (err) {
      setError("Erreur lors du téléchargement du fichier");
      setUploading(false);
      setFile(null);
      setUploaded(false);
    }
  };

  useEffect(() => {
    if (!docRef && uploaded) {
      setFile(null);
      setUploaded(false);
      setError(null);
    }
  }, [docRef, uploaded]);

  return (
    <div className="mb-4">
      <label className="block text-sm font-medium mb-2">
        {label} {required && <span className="text-red-500">*</span>}
      </label>
      <div className="flex items-center flex-wrap md:space-x-4 max-md:gap-y-[10px] ">
        <input
          type="file"
          onChange={handleFileChange}
          className="py-2 px-4 border border-gray-300 rounded-lg text-sm"
          required={required}
          ref={inputRef}
        />
        {uploaded ? (
          <button
            type="button"
            onClick={handleUpload}
            className={`py-2 px-4 rounded-lg text-sm ${
              uploading ? "bg-gray-500" : "bg-green-800"
            } text-white`}
          >
            Ajouté !
          </button>
        ) : (
          <button
            type="button"
            onClick={handleUpload}
            disabled={uploading || !file}
            className={`py-2 px-4 rounded-lg text-sm ${
              uploading ? "bg-gray-500" : "bg-purple-800"
            } text-white`}
          >
            {!file && uploading ? "Ajout en cours..." : "Ajouter"}
          </button>
        )}
      </div>

      {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
      {file && !uploading && (
        <p className="text-red-500 text-sm mt-2">
          N'oubliez pas de cliquer sur "Ajouter" pour confirmer.
        </p>
      )}
    </div>
  );
};

export default FileUploader;
